// extracted by mini-css-extract-plugin
export default {"button":"FavoriteStarToggle_button__yx5pj","icon":"FavoriteStarToggle_icon__4eroV"};